<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Auto Config Enable'" style="height: 100%">
        <div style="margin-left: 10px">
          <input
            type="radio"
            id="autoConfigEnable"
            value="1"
            v-model="autoConfigAdmin"
          />
          <label for="autoConfigEnable">Auto Config Enable</label>
          <input
            type="radio"
            id="autoConfigDisable"
            value="0"
            v-model="autoConfigAdmin"
          />
          <label for="autoConfigDisable">Auto Config Disable</label>
          <button
            type="button"
            class="btn btn-primary"
            @click="setOntAutoConfigAdmin()"
          >
            {{ "Apply" }}
          </button>
        </div>
      </block-cntr>
      <block-cntr :btitle="'ONT Auto Config'" style="height: 410px">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllIndex"
                />
                <label for="idSelectAllIndex"></label>
              </th>
              <th
                v-for="(value, key) in ontAutoConfigTable.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in ontAutoConfigTable.data"
              :key="row.index"
              :class="{ 'true:': true }"
              @click=""
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectAutoConfig' + index"
                  />
                  <label :for="'idRowSelectAutoConfig' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.index }}</div>
              </td>
              <td>
                <div>{{ row.name }}</div>
              </td>
              <td>
                <div>{{ row.ontType }}</div>
              </td>
              <td>
                <div>{{ row.line }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Auto Config Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="configIndex"
                  >Index</label
                >
                <div class="col-sm-5" :class="{ 'has-error': checkIndex() }">
                  <input
                    type="text"
                    class="form-control"
                    id="configIndex"
                    :disabled="isEditClik"
                    v-model="autoConfigForm.index"
                    placeholder="INTEGER<0-1023>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkIndex() ? 'block' : 'none',
                    }"
                    >{{ checkIndex() }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="name">Name</label>
                <div class="col-sm-5" :class="{ 'has-error': checkName() }">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    v-model="autoConfigForm.name"
                    placeholder="STRING<1-128>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkName() ? 'block' : 'none',
                    }"
                    >{{ checkName() }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="ontType"
                  >ONT Type</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="ontType"
                    v-model="autoConfigForm.ontType"
                  >
                    <option value="all-ont">All Type</option>
                    <option
                      v-for="(devType, key, index) in devTypeAll.data"
                      :key="index"
                      :value="devType.type"
                    >
                      {{ devType.type }}({{ devType.desc }})
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="line"
                  >Profile Line</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="line"
                    v-model="autoConfigForm.line"
                  >
                    <option value="auto">auto</option>
                    <option
                      v-for="data in lineTable"
                      :key="data.profileId"
                      :value="data.profileId"
                    >
                      {{ data.profileId + ":" + data.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueGemport",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["uniqueOnt"],

  data() {
    return {
      ontAutoConfigTable: "",
      lineTable: "",
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      devTypeAll: "",
      autoConfigAdmin: 0,
      autoConfigForm: {
        index: "",
        name: "",
        ontType: "",
        line: "",
      },
    }
  },

  created() {
    this.loadontDevInfo()
    this.loadOntAutoConfigAdmin()
    this.loadOntAutoConfigTable()
    this.loadLineProfilePri()
  },

  methods: {
    loadontDevInfo() {
      get("profileontdev")
        .then((res) => {
          this.devTypeAll = res.data
        })
        .catch((err) => {})
    },
    loadOntAutoConfigAdmin() {
      get("ontAutoConfigAdmin")
        .then((res) => (this.autoConfigAdmin = res.data.enable))
        .catch((err) => {})
    },
    loadOntAutoConfigTable() {
      get("ontAutoConfig")
        .then((res) => (this.ontAutoConfigTable = res.data))
        .catch((err) => {})
    },
    loadLineProfilePri() {
      get("profilelinepri")
        .then((res) => {
          this.lineTable = res.data.data
        })
        .catch((err) => {
        })
    },
    setOntAutoConfigAdmin() {
      var postData = {}

      postData["admin"] = Number(this.autoConfigAdmin)
      post("ontAutoConfigAdmin", postData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadOntAutoConfigAdmin()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },

    clkEdit() {
      for (let i = 0; i < this.ontAutoConfigTable.data.length; i++) {
        if (this.ontAutoConfigTable.data[i].selected) {
          this.autoConfigForm.index = this.ontAutoConfigTable.data[i].index
          if (this.ontAutoConfigTable.data[i].name.match(/^INDEX_/) == null) {
            this.autoConfigForm.name = this.ontAutoConfigTable.data[i].name
          }
          this.autoConfigForm.ontType = this.ontAutoConfigTable.data[i].ontType
          this.autoConfigForm.line = this.ontAutoConfigTable.data[i].line
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.ontAutoConfigTable.data.length; i++) {
        if (this.ontAutoConfigTable.data[i].selected) {
          list.push({
            index: Number(this.ontAutoConfigTable.data[i].index),
          })
        }
      }
      if (list.length == 0) {
        return
      }
      delData["autoConfigList"] = list
      post("ontAutoConfigDelete", delData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadOntAutoConfigTable()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.loadOntAutoConfigTable()
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var autoConfigFormTmp = {
        index: "",
        name: "",
        ontType: "",
        line: "",
      }
      this.autoConfigForm = autoConfigFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.ontAutoConfigTable.data.length; i++) {
        if (this.isSelectAll) {
          this.ontAutoConfigTable.data[i].selected = true
        } else {
          this.ontAutoConfigTable.data[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.ontAutoConfigTable.data.length; i++) {
        this.ontAutoConfigTable.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkApply() {
      var newAutoConfig = {
        index: Number(this.autoConfigForm.index),
        name: this.autoConfigForm.name,
        ontType: this.autoConfigForm.ontType,
        line: Number(this.autoConfigForm.line),
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.ontAutoConfigTable.data.length; i++) {
          if (newAutoConfig.index == this.ontAutoConfigTable.data[i].index) {
            this.showAlertBox("warn", "Message", "This index has been created")
            return
          }
        }
      }
      if (
        (this.autoConfigForm.index == "" && this.autoConfigForm.name == "") ||
        this.autoConfigForm.ontType == "" ||
        this.autoConfigForm.line == ""
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }
      if (this.checkIndex()) {
        this.showAlertBox("warn", "Message", "Invalid index")
        return
      }
      if (this.autoConfigForm.name.length > 128 || this.checkName()) {
        this.showAlertBox("warn", "Message", "Invalid name")
        return
      }

      if (this.autoConfigForm.index == "") {
        newAutoConfig.index = -1
      }

      if (this.autoConfigForm.line == "auto") {
        newAutoConfig.line = -1
      }

      post("ontAutoConfig", newAutoConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadOntAutoConfigTable()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },
    checkIndex() {
      if (this.autoConfigForm.index != "") {
        let index = Number(this.autoConfigForm.index)
        if (!isNaN(index)) {
          if (index < 0 || index > 1023) return "index must be in range 0-1023"
        } else return "index must be in range 0-1023"
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    checkName() {
      if (nonASCIIchar(this.autoConfigForm.name)) {
        return nonASCIIchar(this.autoConfigForm.name)
      }
      if (this.autoConfigForm.name.split(" ").length > 1) {
        return "invalid name"
      }
      return null
    },
  },
}
</script>
